module.exports = __webpack_public_path__ + "img/512.1ec671eb.jpg";